module.exports = __webpack_public_path__ + "img/02n.c9cb199e.gif";